module.exports = __webpack_public_path__ + "img/hidden.b2a3ff91.png";